import { FETCH_LABEL_TRANSLATION } from './actionTypes';

export const LabelTranslationReducer = (state, action) => {
    if(action.type === FETCH_LABEL_TRANSLATION) {     
        return { 
            ...state, 
            language: action.payload.language,
            labels: action.payload.labels 
        }
    }
    else { 
        return state;   
    }     
}
